import { render, staticRenderFns } from "./SearchNavItemKeyword.vue?vue&type=template&id=47e0a58c&scoped=true&"
import script from "./SearchNavItemKeyword.vue?vue&type=script&lang=js&"
export * from "./SearchNavItemKeyword.vue?vue&type=script&lang=js&"
import style0 from "./SearchNavItemKeyword.vue?vue&type=style&index=0&id=47e0a58c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e0a58c",
  null
  
)

export default component.exports